import parse, { attributesToProps, DOMNode, domToReact, Element, Text } from 'html-react-parser';
import ReactDomServer from 'react-dom/server';
import removeAccents from 'remove-accents';

import { schemas } from '@/network/client';

interface NodeItem {
  tag: string;
  text: string;
  sectionId: string;
}

export interface NodeItemId extends NodeItem {
  id: string;
  section: string;
  subheadings?: NodeItemId[];
}

export const parseBlogPostHeaders = (sections: schemas['DescriptionItems'][]) => {
  const nodes: NodeItemId[] = [];
  sections
    .flatMap((section) => section.items || [])
    .forEach((item) => {
      if (item.type === 'TEXT') {
        const parsedContent = parse(item.content || '', {
          replace: (domNode) => {
            if (domNode instanceof Element && (domNode.name === 'h2' || domNode.name === 'h3')) {
              const text = domNode.children
                .filter((item) => item.type === 'text')
                .map((item) => (item as Text).data)
                .join(' ');
              const id = removeAccents(text).toLowerCase().trim().replace(/ /g, '-');

              if (domNode.name === 'h2') {
                const section = String(nodes.length + 1);
                const sectionId = `section-${section}`;
                nodes.push({
                  tag: domNode.name,
                  text: text.trim(),
                  sectionId,
                  id,
                  section,
                  subheadings: [],
                });
                const props = attributesToProps(domNode.attribs);
                return (
                  <h2 {...props} id={id}>
                    {domToReact(domNode.children as DOMNode[])}
                  </h2>
                );
              }
              if (domNode.name === 'h3') {
                const currentH2 = nodes[nodes.length - 1];
                const section = `${nodes.length}.${currentH2?.subheadings?.length || 0 + 1}`;
                const sectionId = `section-${section}`;

                if (currentH2) {
                  currentH2.subheadings?.push({
                    tag: domNode.name,
                    text: text,
                    id,
                    sectionId,
                    section,
                  });
                }
                const props = attributesToProps(domNode.attribs);
                return (
                  <h3 {...props} id={id}>
                    {domToReact(domNode.children as DOMNode[])}
                  </h3>
                );
              }
            }
          },
        });
        // @ts-expect-error render to string parsed html
        item.content = ReactDomServer.renderToString(parsedContent);
      }
    });

  return nodes;
};
